import * as React from "react";
import { useRouter } from "next/router";
import { Login } from "@grandvisionhq/auth";
import { CmsHeadTags } from "@grandvisionhq/bloomreach";
import { isSafePath } from "@grandvisionhq/frk-routing";
import { useIntl } from "@grandvisionhq/state";
import { StringGuard } from "@grandvisionhq/utils";
import { A as AuthPageLayout } from "../../auth-page.js";
const Page = () => {
  const { getLabel } = useIntl();
  const { query } = useRouter();
  const rawReturnPath = query.returnPath;
  const safeReturnPath = isSafePath(rawReturnPath) ? rawReturnPath : "/";
  return /* @__PURE__ */ React.createElement(AuthPageLayout, { hasTwoColumns: true }, /* @__PURE__ */ React.createElement(CmsHeadTags, { title: getLabel("account.login.title"), noFollow: true, noIndex: true }), /* @__PURE__ */ React.createElement(
    Login,
    {
      returnPath: safeReturnPath,
      error: query.error ? StringGuard.guard("error", query.error) : void 0,
      email: query.email ? StringGuard.guard("email", query.email) : void 0,
      socialLoginButtonLabel: "account.login.social.google"
    }
  ));
};
export {
  Page
};
//# sourceMappingURL=login.js.map
